import React, { useEffect, useState } from "react";
import { DataTable, Icon, Modal } from "../../components/widgets";
import { useDispatch, useSelector } from "react-redux";
import { deleteScaleDeviceInfo, scaleDeviceList } from "../../actions/scale-device";
import { validateCollections } from "../../helpers/common";


const ScaleList = ({ isScale, setShow, setEditModal, setEditScaleId }) => {
  const dispatch = useDispatch();
  const farmId = useSelector(state => state.farm.currentFarm.farm_uuid);
  const scaleInfo = useSelector(state => state.scaleDevice.scaleInfo);
  const [showDeleteModal, setDeleteModal] = useState(false);
  const [scaleDeviceUuid, setScaleDeviceUuid] = useState("");

  const scaleDetails = validateCollections(scaleInfo) ? scaleInfo : [];
  useEffect(() => {
    const params = {
      farm_uuid: farmId
    }
    dispatch(scaleDeviceList(params));
  }, []);

  const deleteScale = () => {
    const params = {
      farm_uuid: farmId,
      scale_device_uuid: scaleDeviceUuid
    }
    dispatch(deleteScaleDeviceInfo(params));
  }

  const handleEdit = (scaleDeviceId) => {
    setShow(true);
    setEditModal(true)
    setEditScaleId(scaleDeviceId);
  }
  return (
    <>
      <DataTable className={`tbl-fixed ${isScale ? "d-block" : "d-none"}`} >
        <DataTable.Header>
          <DataTable.Row>
            <DataTable.Cell style={{ width: "40px" }}>
              #
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "90px", cursor: "pointer" }}>
              Scale Device Id
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "110px", cursor: "pointer" }}>
              Scale Device Name
            </DataTable.Cell>
            <DataTable.Cell style={{ width: "20px" }}>
              Actions
            </DataTable.Cell>
          </DataTable.Row>
        </DataTable.Header>
        <DataTable.Body>
          {scaleDetails.map((it, index) => <DataTable.Row key={`scaleList-${index}`}>
            <DataTable.Cell style={{ width: "40px" }}>{index + 1}</DataTable.Cell>
            <DataTable.Cell style={{ width: "90px", cursor: "pointer" }}>{it.scale_device_uuid}</DataTable.Cell>
            <DataTable.Cell style={{ width: "110px", cursor: "pointer" }}>{it.name}</DataTable.Cell>
            <DataTable.Cell style={{ width: "20px" }} >
              <Icon className={`fa fa-pencil ml-2 cursor-pointer`} title="Edit" onClick={() => handleEdit(it.scale_device_uuid)} />
              <Icon className={`fa fa-trash ml-2 cursor-pointer`} title="Delete" onClick={() => {
                setDeleteModal(true);
                setScaleDeviceUuid(it.scale_device_uuid)
              }} />
            </DataTable.Cell>
          </DataTable.Row>)}
        </DataTable.Body>
      </DataTable>
      <Modal.Confirm
        className="modal-bordered modal-danger"
        show={showDeleteModal}
        onConfirm={deleteScale}
        iconClassName="fa fa-question"
        title={{ content: "Confirmation" }}
        content={`Do you want to delete??`}
        variant="info"
        confirmButton={{ variant: "danger" }}
        onCancel={() => setDeleteModal(false)}
        onHide={() => setDeleteModal(false)}
      />
    </>
  );
}

export default ScaleList;